import { type ReactElement } from 'react';

// One labelled row of a form, and the one control shape every form uses. Both
// booking dialogs draw from here so a field never reads differently in one.
export const INPUT =
  'h-11 w-full rounded-xl border bg-background px-3 text-base outline-none focus:ring-2 focus:ring-ring';

export function Field({
  label,
  children,
}: {
  label: string;
  children: ReactElement;
}): ReactElement {
  return (
    <label className="flex min-w-0 flex-col gap-1 text-[13px]">
      <span className="font-medium text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}
